// extracted by mini-css-extract-plugin
export default {"body":"ingredient-details_body__8pGI9","nutrients":"ingredient-details_nutrients__Lk1iM","fixedImageHeight":"ingredient-details_fixedImageHeight__+7ny0"};